import { Injectable } from '@angular/core';

const LB_STORAGE_PREFIX = 'lb_assignment_';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {}

  getLocalStorageKeys(): string[] {
    const keys: string[] = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        keys.push(key);
      }
    }

    return keys;
  }

  setLoadBalancerAssignment(pluginName: string, url: string): void {
    localStorage.setItem(LB_STORAGE_PREFIX + pluginName, JSON.stringify({ url, assignedAt: Date.now() }));
  }

  removeLoadBalancerAssignment(pluginName: string): void {
    localStorage.removeItem(LB_STORAGE_PREFIX + pluginName);
  }

  clearLoadBalancerAssignments(): void {
    for (const key of this.getLocalStorageKeys()) {
      if (key.startsWith(LB_STORAGE_PREFIX)) {
        localStorage.removeItem(key);
      }
    }
  }

  getLoadBalancerAssignments(): Map<string, string> {
    const assignments = new Map<string, string>();

    for (const key of this.getLocalStorageKeys()) {
      if (!key.startsWith(LB_STORAGE_PREFIX)) {
        continue;
      }

      const pluginName = key.substring(LB_STORAGE_PREFIX.length);
      const raw = localStorage.getItem(key);
      if (!raw) {
        continue;
      }

      const stored = JSON.parse(raw);
      if (stored?.url) {
        assignments.set(pluginName, stored.url);
      }
    }

    return assignments;
  }

  setSoftphoneUrl() {
    if (document.location.href.includes('AgentType=Login')) {
      localStorage.setItem('loginsoftphoneUrl', document.location.href);
    } else {
      localStorage.setItem('softphoneUrl', document.location.href);
    }
  }

  getSoftphoneUrl() {
    if (document.location.href.includes('AgentType=Login')) {
      return localStorage.getItem('loginsoftphoneUrl');
    } else {
      return localStorage.getItem('softphoneUrl');
    }
  }

  static getLogoPath() {
    if (document.location.href.includes('avaya')) {
      return 'avayaLogo.png';
    } else {
      return 'da_vinci.png';
    }
  }
}
